/* eslint-disable @typescript-eslint/no-explicit-any */

export type PuppeteerPayload = { html: string; launchArgs: any; pdfArgs: any };
